import { render } from "./raceInfo.vue?vue&type=template&id=2a28fb08&scoped=true"
import script from "./raceInfo.vue?vue&type=script&lang=js"
export * from "./raceInfo.vue?vue&type=script&lang=js"

import "./raceInfo.vue?vue&type=style&index=0&id=2a28fb08&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a28fb08"]])

export default __exports__